// test1526
(1526 && 0);
